import { render, staticRenderFns } from "./documentForm.vue?vue&type=template&id=400a845e&"
import script from "./documentForm.vue?vue&type=script&lang=js&"
export * from "./documentForm.vue?vue&type=script&lang=js&"
import style0 from "./documentForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports